import { CommonModule } from '@angular/common';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgxPaginationModule } from 'ngx-pagination';

import { AppSessionService } from './session/app-session.service';
import { AppUrlService } from './nav/app-url.service';
import { AppAuthService } from './auth/app-auth.service';
import { AppRouteGuard } from './auth/auth-route-guard';
import { LocalizePipe } from '@shared/pipes/localize.pipe';

import { AbpPaginationControlsComponent } from './components/pagination/abp-pagination-controls.component';
import { AbpValidationSummaryComponent } from './components/validation/abp-validation.summary.component';
import { AbpModalHeaderComponent } from './components/modal/abp-modal-header.component';
import { AbpModalFooterComponent } from './components/modal/abp-modal-footer.component';
import { VerifyButtonComponent } from './components/verify-button/verify-button.component';
import { SupportBubbleComponent } from './components/support-bubble/support-bubble.component';
import { LayoutStoreService } from './layout/layout-store.service';

import { BlockDirective } from './directives/block.directive';
import { BusyDirective } from './directives/busy.directive';
import { EqualValidator } from './directives/equal-validator.directive';
import { ParaguayanRucValidatorDirective } from './directives/paraguayan-ruc-validator.directive';
import { DateParaguayPipe } from './pipes/date-paraguay.pipe';
import { ThousandsPipe } from './pipes/thousands.pipe';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        NgxPaginationModule
    ],
    declarations: [
        AbpPaginationControlsComponent,
        AbpValidationSummaryComponent,
        AbpModalHeaderComponent,
        AbpModalFooterComponent,
        VerifyButtonComponent,
        SupportBubbleComponent,
        LocalizePipe,
        BlockDirective,
        BusyDirective,
        EqualValidator,
        ParaguayanRucValidatorDirective,
        DateParaguayPipe,
        ThousandsPipe
    ],
    exports: [
        AbpPaginationControlsComponent,
        AbpValidationSummaryComponent,
        AbpModalHeaderComponent,
        AbpModalFooterComponent,
        VerifyButtonComponent,
        SupportBubbleComponent,
        LocalizePipe,
        BlockDirective,
        BusyDirective,
        EqualValidator,
        ParaguayanRucValidatorDirective,
        DateParaguayPipe,
        ThousandsPipe
    ]
})
export class SharedModule {
    static forRoot(): ModuleWithProviders<SharedModule> {
        return {
            ngModule: SharedModule,
            providers: [
                AppSessionService,
                AppUrlService,
                AppAuthService,
                AppRouteGuard,
                LayoutStoreService
            ]
        };
    }
}
